import React, { useCallback } from 'react'
import MultiSelect from '../../common/MultiSelect.tsx'
import type { SoundDesignParameters } from '../../../features/sound-design/domain/models/sound-design-parameters.ts'
import type { SoundDesignFilters } from '../../../features/sound-design/domain/models/sound-design-filters.ts'

interface SoundDesignBoxListFiltersProps {
  setFilters: (
    filters:
      | SoundDesignFilters
      | ((prevFilters: SoundDesignFilters) => SoundDesignFilters)
  ) => void
  parameters: SoundDesignParameters | undefined
  filters: SoundDesignFilters
}

const SoundDesignBoxListFilters: React.FC<SoundDesignBoxListFiltersProps> = ({
  setFilters,
  parameters,
  filters,
}) => {
  const handleFilterChange = useCallback(
    (newFilter: SoundDesignFilters) => {
      setFilters((prevFilters) => ({
        ...prevFilters,
        ...newFilter,
      }))
    },
    [setFilters]
  )

  return (
    <div className="grid w-full grid-cols-2 gap-2">
      <MultiSelect
        options={parameters?.moods}
        onChange={(selected) => handleFilterChange({ moods: selected })}
        filterNameKey={'ls_filter_buttons_mood'}
        hasSelectAll
        initialSelected={filters.moods}
      />
      <MultiSelect
        options={parameters?.genres}
        onChange={(selected) => handleFilterChange({ genres: selected })}
        filterNameKey={'ls_filter_buttons_genre'}
        hasSelectAll
        initialSelected={filters.genres}
      />
      <MultiSelect
        options={parameters?.instruments}
        onChange={(selected) => handleFilterChange({ instruments: selected })}
        filterNameKey={'ls_filter_buttons_instrument'}
        hasSelectAll
        initialSelected={filters.instruments}
      />
      <MultiSelect
        options={parameters?.bpms}
        onChange={(selected) => handleFilterChange({ bpms: selected })}
        filterNameKey={'ls_filter_buttons_bpm'}
        hasSelectAll
        initialSelected={filters.bpms}
      />
    </div>
  )
}

export default SoundDesignBoxListFilters
